import {
    Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
    DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Typography, Checkbox,
    TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { exportarExcel, formatTime, mesName } from '../../utils/utils';
import DownloadIcon from '@mui/icons-material/Download';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { AlertError } from '../../utils/componentes-utiles/AlertError';
import { useNavigate } from 'react-router-dom';
import { getTodosFichajes, getTodosFichajesDescarga, getTrabajadores } from '../../services/apis';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; 

import { exportarPDF } from '../../utils/utils';

export const DialogDescargaFichajes = ({ open, setOpen }) => {
    const [fichajes, setFichajes] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [nombreMes, setNombreMes] = useState(mesName(mes));
    const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [showError, setShowError] = useState(false);

    const [fechaInicio, setFechaInicio] = useState(() => new Date().toISOString().split('T')[0]);
    const [fechaFin, setFechaFin] = useState(() => new Date().toISOString().split('T')[0]);

    const [opTrabajadores, setOpTrabajadores] = useState([]);
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const navigate = useNavigate();
    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };
    const today = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 1);
    const [filtros, setFiltros] = useState(
        {
            fechaDesde: formatDate(twoMonthsAgo),  // Fecha de hace 2 meses
            fechaHasta: formatDate(today),         // Fecha actual

        }
    );
    const handleClose = () => setOpen(false);

    const consultarFichajes = async () => {
        try {
            const response = await getTodosFichajes(filtros.fechaDesde, filtros.fechaHasta, selectedUsers);
            setFichajes(response.data.fichajes);
            setYears(response.data.years);
            setSelectedUsers([]);
            setAllSelected(false);
            setLoaded(true);
        } catch (error) {
            console.error("Error al obtener los fichajes:", error);
        }
    };

    useEffect(() => {
        consultarFichajes();
        setNombreMes(mesName(mes));
    }, [mes, yearSelected]);

    useEffect(() => {
        consultarFichajes();
    }, []);

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(fichajes.map(f => f.id));
        }
        setAllSelected(!allSelected);
    };

    const handleUserToggle = (id) => {
        setSelectedUsers((prev) =>
            prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
        );
    };

    const descargarFichajesDelMes = async () => {
        try {
            const response = await getTodosFichajesDescarga(filtros.fechaDesde, filtros.fechaHasta, selectedUsers
            );


            const fichajes = response?.data?.fichajes ?? [];

            // Crear objeto con parámetros utilizados
            const parametrosExportacion = {
                usuarios: selectedUsers,
                fechaDesde: filtros.fechaDesde,
                fechaHasta: filtros.fechaHasta,
                totalUsuarios: selectedUsers.length
            };

            console.log("Parámetros de exportación:", parametrosExportacion);
            console.log("Fichajes devueltos:", fichajes);

            const exportado = exportarPDF(
                fichajes,
                `fichajes_${filtros.fechaDesde}_${filtros.fechaHasta}`,
                {
                    fechaDesde: filtros.fechaDesde,
                    fechaHasta: filtros.fechaHasta,
                    totalUsuarios: selectedUsers.length,
                }
            );

            if (!exportado) {
                setShowError(true);
            }
        } catch (error) {
            console.error("Error al descargar los fichajes:", error);
            setShowError(true);
        }
    };


    const descargarFichajesDelMesUsuario = async (usuario) => {
        let selectedUsers = [usuario];
        try {
            const response = await getTodosFichajesDescarga(filtros.fechaDesde, filtros.fechaHasta, selectedUsers
            );


            const fichajes = response?.data?.fichajes ?? [];

            // Crear objeto con parámetros utilizados
            const parametrosExportacion = {
                usuarios: selectedUsers,
                fechaDesde: filtros.fechaDesde,
                fechaHasta: filtros.fechaHasta,
                totalUsuarios: selectedUsers.length
            };

            console.log("Parámetros de exportación:", parametrosExportacion);
            console.log("Fichajes devueltos:", fichajes);

            // Generar el archivo Excel
            const exportado = exportarExcel(
                fichajes,
                `fichajes_${filtros.fechaDesde}_${filtros.fechaHasta}`
            );

            if (!exportado) {
                setShowError(true);
            }
        } catch (error) {
            console.error("Error al descargar los fichajes:", error);
            setShowError(true);
        }
    };


    const handleChange = (event) => {

        const tareaNueva = { ...filtros, [event.target.name]: event.target.value };

        setFiltros(tareaNueva);
        if (event.target.name == ('fechaDesde' || 'fechaHasta')) {
            consultarFichajes();
        }

    }


    useEffect(() => {
        const cargarTrabajadores = async () => {
            try {
                const response = await getTrabajadores();
                const opciones = response.data.map(item => ({
                    label: item.nombre,
                    value: item.id
                }));
                setOpTrabajadores(opciones);
            } catch (err) {
                console.error('Error al cargar trabajadores', err);
            }
        };
        if (open) {
            cargarTrabajadores();
        }
    }, [open]);

    useEffect(() => {
        const ids = trabajadorSelec.map(t => t.value);
        setSelectedUsers(ids);
    }, [trabajadorSelec]);
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Descargar fichajes</DialogTitle>
            <DialogContent>
                {!loaded ? (
                    <Box display="flex" justifyContent="center" py={3}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Grid container spacing={2} alignItems="center" mb={2} padding={2}>
                            <Grid item xs={12} md={2}>
                                <Typography variant="h6">Desde:</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    label="Fecha Desde"
                                    type="date"
                                    name="fechaDesde"
                                    value={filtros.fechaDesde}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    label="Fecha Hasta"
                                    type="date"
                                    name="fechaHasta"
                                    value={filtros.fechaHasta}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {allSelected ? (
                                                <CheckBoxIcon
                                                    color="primary"
                                                    onClick={toggleSelectAll}
                                                    sx={{ cursor: 'pointer' }}
                                                />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    color="primary"
                                                    onClick={toggleSelectAll}
                                                    sx={{ cursor: 'pointer' }}
                                                />
                                            )}                                        </TableCell>
                                        <TableCell><strong>Empleado</strong></TableCell>
                                        <TableCell><strong>Horas</strong></TableCell>
                                        <TableCell><strong> </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fichajes.map((usuario) => (
                                        <TableRow key={usuario.id}>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={selectedUsers.includes(usuario.id)}
                                                    onChange={() => handleUserToggle(usuario.id)}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <strong>{usuario.usuario}</strong>
                                                <Box display="flex" alignItems="center" mt={0.5}>
                                                    <FiberManualRecordIcon
                                                        sx={{ color: usuario.activo ? 'green' : 'red', fontSize: 14, mr: 0.5 }}
                                                    />
                                                    <Typography variant="body2" sx={{ color: usuario.activo ? 'green' : 'red' }}>
                                                        {usuario.activo ? 'Activo' : 'No Activo'}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <strong>{formatTime(usuario.sumaFichaje)}</strong>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button onClick={() => navigate(`/fichajesusuario/${usuario.id}`)}>
                                                    <DownloadIcon color="primary" />
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={descargarFichajesDelMes} variant='contained' disabled={selectedUsers.length === 0}>
                    Descargar seleccionados    <DownloadIcon />
                </Button>
            </DialogActions>

            <AlertError
                open={showError}
                setOpen={setShowError}
                titulo="Error"
                mensaje="No se ha podido exportar los fichajes"
            />
        </Dialog>
    );
};
